"use client";

import React from 'react';

export default function NewsletterSection({ settings }: { settings?: any }) {
  const [email, setEmail] = React.useState("");
  const [isSubmitted, setIsSubmitted] = React.useState(false);
  const [error, setError] = React.useState("");

  const title = settings?.newsletterTitle || "İndirimlerden Haberdar Olun";
  const desc = settings?.newsletterDesc || "Yeni ürünler, özel etkinlikler ve kampanyalar e-postanızda.";

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setError("");
    try {
      const res = await fetch("/api/newsletter", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        setError(data.error || "Bir hata oluştu, tekrar deneyin.");
        return;
      }
      setIsSubmitted(true);
      setEmail("");
      setTimeout(() => setIsSubmitted(false), 5000);
    } catch {
      setError("Bir hata oluştu, tekrar deneyin.");
    }
  };

  return (
    <section className="py-32 px-6 bg-black">
      <div className="max-w-4xl mx-auto text-center space-y-12">
        <div className="space-y-4">
          <div className="text-accent text-[10px] uppercase tracking-[0.4em] font-bold">E-POSTA BÜLTENİ</div>
          <h2 className="font-serif text-5xl md:text-6xl font-light tracking-tight text-white">
            {title}
          </h2>
          <p className="text-luxury/40 text-sm font-light max-w-sm mx-auto">{desc}</p>
        </div>

        {isSubmitted ? (
          <div className="p-8 border border-accent/20 bg-accent/5 rounded animate-in fade-in zoom-in duration-500">
             <p className="text-accent text-xs uppercase tracking-widest font-bold">Aramıza Hoş Geldiniz. Kaydınız Başarıyla Alındı.</p>
          </div>
        ) : (
          <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row gap-0 border border-white/10 rounded-sm overflow-hidden focus-within:border-accent/40 transition-colors">
            <input 
              type="email" 
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="E-POSTA ADRESİNİZ" 
              className="flex-1 bg-white/[0.03] px-6 py-5 text-[10px] tracking-widest uppercase focus:outline-none placeholder:text-luxury/20 text-white"
            />
            <button type="submit" className="bg-accent text-black px-10 py-5 text-[10px] font-bold uppercase tracking-widest hover:bg-white transition-all">
              KATILIN
            </button>
          </form>
        )}
        {error && <p className="text-red-400 text-[10px] uppercase tracking-widest">{error}</p>}
        <p className="text-[8px] text-luxury/20 uppercase tracking-widest">ABONE OLARAK GİZLİLİK POLİTİKAMIZI KABUL ETMİŞ OLURSUNUZ.</p>
      </div>
    </section>
  );
}
